module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validators),
      expression: "validators"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('XXX-XXX-XXXX'),
      expression: "'XXX-XXX-XXXX'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name,
      "name": _vm.field.name,
      "data-vv-as": _vm.field.description.replace(/\./g, ''),
      "readonly": _vm.locked
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.input,
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bca481c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/PhoneRender.vue
// module id = 1719
// module chunks = 1